import { makeStyles } from "@material-ui/core/styles";
export default makeStyles((theme) => ({
  button: { 
    width: "100%" 
  },
  buttonContainer: {
    marginTop: theme.spacing(4)
  },
  refreshButton: {
    marginTop: 0
  }
}), { index: 1 })